import { AppShell } from '~/components/layout/app-shell'
import { Button } from '~/components/ui/button'
import { Badge } from '~/components/ui/badge'
import { ErrorBanner } from '~/components/ui/error-banner'
import { EmptyState } from '~/components/shared/empty-state'
import { MaintenanceAnalysisWorkspace } from './analysis-workspace'
import { AssessmentSelectionStep } from './assessment-selection-step'
import { useMaintenanceSession } from './use-maintenance-session'

/** HACCP 유지하기 AI — 대화형 변경 영향 분석 + 이력. */
export function MaintenancePage() {
    const session = useMaintenanceSession()
    const {
        assessments,
        step,
        selectedId,
        setSelectedId,
        listError,
        activeEvent,
        startAnalysisStep,
        returnToAssessmentStep,
    } = session

    return (
        <AppShell>
            <div className='h-full overflow-hidden'>
                <div className='mx-auto flex h-full w-full max-w-[1680px] flex-col px-4 py-6 lg:px-8 2xl:px-10'>
                    <div
                        className={`mb-4 flex w-full shrink-0 items-end justify-between gap-4 ${
                            step === 'select-assessment'
                                ? 'mx-auto max-w-[1280px]'
                                : ''
                        }`}>
                        <div>
                            <h1 className='text-foreground text-lg font-semibold'>
                                HACCP 변경 검토 AI
                            </h1>
                        </div>
                        <div className='flex items-center gap-2'>
                            {step === 'analyze-change' ? (
                                <Button
                                    type='button'
                                    variant='outline'
                                    size='sm'
                                    onClick={returnToAssessmentStep}
                                    className='rounded-sm'>
                                    대상 평가 변경
                                </Button>
                            ) : null}
                            <Badge
                                tone={
                                    step === 'select-assessment' || !activeEvent
                                        ? 'info'
                                        : 'success'
                                }>
                                {step === 'select-assessment'
                                    ? '1단계 대상 평가'
                                    : activeEvent
                                      ? '3단계 분석 상세'
                                      : '2단계 변경 입력'}
                            </Badge>
                        </div>
                    </div>

                    {listError ? (
                        <ErrorBanner className='mb-3 shrink-0'>
                            {listError}
                        </ErrorBanner>
                    ) : null}

                    {assessments === null ? (
                        <div className='border-border bg-card rounded-sm border p-6'>
                            <p className='text-muted-foreground text-sm'>
                                평가 목록을 불러오는 중…
                            </p>
                        </div>
                    ) : assessments.length === 0 ? (
                        <EmptyState
                            title='등록된 평가가 없어요'
                            description='변경 검토는 저장된 평가를 기준으로 진행돼요. 먼저 HACCP 모의 평가 AI에서 평가를 만들어 주세요.'
                        />
                    ) : step === 'select-assessment' ? (
                        <AssessmentSelectionStep
                            assessments={assessments}
                            selectedId={selectedId}
                            onSelect={setSelectedId}
                            onStart={startAnalysisStep}
                        />
                    ) : (
                        <MaintenanceAnalysisWorkspace session={session} />
                    )}
                </div>
            </div>
        </AppShell>
    )
}
